// Oculta todo al cargar
document.addEventListener("DOMContentLoaded", function () {
  document.getElementById('pleyer-especificaciones')?.classList.remove('active');
  document.getElementById('pleyer-beneficios')?.classList.remove('active');
  document.getElementById('pleyer-btn-especificaciones')?.classList.remove('active');
  document.getElementById('pleyer-btn-beneficios')?.classList.remove('active');
});

function pleyerToggleTab(tab) {
  const btnEspecificaciones = document.getElementById('pleyer-btn-especificaciones');
  const btnBeneficios = document.getElementById('pleyer-btn-beneficios');
  const contEspecificaciones = document.getElementById('pleyer-especificaciones');
  const contBeneficios = document.getElementById('pleyer-beneficios');

  if (tab === 'especificaciones') {
    const isVisible = contEspecificaciones.classList.contains('active');

    contEspecificaciones.classList.remove('active');
    contBeneficios.classList.remove('active');
    btnEspecificaciones.classList.remove('active');
    btnBeneficios.classList.remove('active');

    if (!isVisible) {
      contEspecificaciones.classList.add('active');
      btnEspecificaciones.classList.add('active');
    }
  }

  else if (tab === 'beneficios') {
    const isVisible = contBeneficios.classList.contains('active');

    contEspecificaciones.classList.remove('active');
    contBeneficios.classList.remove('active');
    btnEspecificaciones.classList.remove('active');
    btnBeneficios.classList.remove('active');

    if (!isVisible) {
      contBeneficios.classList.add('active');
      btnBeneficios.classList.add('active');
    }
  }
}

